import React from 'react';
import DaoSections from '../../components/ptgc/dao/Index';  // ✅ Fix import

const DaoPage = () => {
  return (
    <>
      <DaoSections />  {/* ✅ Fix component usage */}
    </>
  );
};

export default DaoPage;